const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white py-4 text-center text-sm text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-2 sm:flex-row sm:justify-between sm:space-y-0">
          <p>© {currentYear} Gnzabe. All rights reserved.</p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Powered by{" "}
            <a
              href="https://cctechet.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 transition-colors"
            >
              CCTechet
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
